import { ChangeEvent } from 'react'
import classNames from 'classnames'

import { CircleCloseIcon } from '../../../icons/CircleCloseIcon'
import { SearchIcon } from '../../../icons/SearchIcon'

import styles from './InputSearch.module.scss'

export interface InputSearchProps {
  className?: string
  value?: string
  placeholder?: string
  size?: 'regular' | 'compact'
  isFullWidth?: boolean
  isAutoFocus?: boolean
  delay?: number
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void
  onClear?: () => void
  onClick?: () => void
}

export const InputSearch: React.FC<InputSearchProps> = (props) => {
  const {
    className,
    value,
    placeholder,
    size = 'regular',
    isFullWidth,
    isAutoFocus,
    onChange,
    onClear,
    onClick,
  } = props

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event)
  }

  const handleClear = () => {
    onClear?.()
  }

  const handleClick = () => {
    onClick?.()
  }

  return (
    <div
      className={classNames(styles.inputSearch, className, {
        [styles.compact]: size === 'compact',
        [styles.fullWidth]: isFullWidth,
      })}
      onClick={handleClick}
    >
      <SearchIcon />
      <input
        type='text'
        placeholder={placeholder}
        value={value}
        onChange={handleChange}
        autoFocus={isAutoFocus}
      />
      <button onClick={handleClear}>
        {!!value?.length && <CircleCloseIcon color='foregroundSecondary' />}
      </button>
    </div>
  )
}
